import React from 'react';

interface MemoIconProps {
  color?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const MemoIcon: React.FC<MemoIconProps> = ({
  color = '#919191',
  size = 32,
  strokeWidth = 2,
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 48 48"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        height="32"
        rx="6"
        stroke={color}
        strokeWidth={strokeWidth}
        width="28"
        x="10"
        y="8"
      />

      {/* Three horizontal memo lines */}
      <line
        stroke={color}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        x1="17"
        x2="31"
        y1="18"
        y2="18"
      />
      <line
        stroke={color}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        x1="17"
        x2="31"
        y1="24"
        y2="24"
      />
      <line
        stroke={color}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        x1="17"
        x2="27"
        y1="30"
        y2="30"
      />
    </svg>
  );
};

export default MemoIcon;
